import { GridItem, GridItemProps } from "@chakra-ui/react"

function DescriptionTerm({ children, ...rest }: { children: React.ReactNode } & GridItemProps) {
  return (
    <GridItem as="dt" {...rest}>
      {children}
    </GridItem>
  )
}

export default DescriptionTerm
